// ═══════════════════════════════════════════════════════════════════════════
// N° DE TVA D'UN FORMULAIRE PUBLIC : UN NUMÉRO VALIDE, OU « PAS ENCORE » DIT EN CLAIR
//
// Décision fondateur du 08/10/2026. Le popup lead magnet exigeait un n° de TVA
// belge valide depuis le 10/09/2026. Étendu aux quatre formulaires de demande
// de contact, ce blocage aurait refusé exactement le prospect qu'on cherche :
// une société en création, un premier engagement, une ASBL non assujettie, qui
// n'ont pas (encore) de n° de TVA. D'où la seule alternative admise : cocher
// « pas encore de n° de TVA ». Rien d'autre ne passe — un champ laissé vide
// sans la case cochée reste refusé, et un n° rempli doit être valide (clé MOD 97).
//
// Module PUR : le même verdict sert le navigateur (confort) et la route
// (le seul contrôle qui tienne, une route publique s'appelle en POST direct).
// La règle n'est écrite qu'ici (R14 bis) : ne jamais la recopier dans une route.
//
// Formule de contrôle : cf. bce-format.js (algorithme public, pas une constante
// légale au sens de R1).
// ═══════════════════════════════════════════════════════════════════════════
import { estNumeroTvaBelgeValide, normaliserBce } from './bce-format';

export const LIBELLE_PAS_ENCORE_TVA = 'Pas encore de n° de TVA';

const estVrai = (v) => v === true || v === 'true' || v === 1 || v === '1';

/**
 * @param {*} tva         valeur saisie (peut être vide)
 * @param {*} pasEncore   case « je n'ai pas encore de n° de TVA » cochée
 * @returns {{ok: true, tva: string|null, libelle: string}|{ok: false, erreur: string}}
 *   `tva` = « BE0123456749 » ou null quand « pas encore » ; `libelle` = ce qu'affiche le mail interne.
 */
export function controlerTvaOuPasEncore(tva, pasEncore) {
  if (estVrai(pasEncore)) return { ok: true, tva: null, libelle: LIBELLE_PAS_ENCORE_TVA };
  const brut = String(tva == null ? '' : tva).trim();
  if (!brut) return { ok: false, erreur: 'Numéro de TVA requis, ou cochez « pas encore de n° de TVA ».' };
  if (!estNumeroTvaBelgeValide(brut)) return { ok: false, erreur: 'Numéro de TVA belge invalide.' };
  const valeur = 'BE' + normaliserBce(brut);
  return { ok: true, tva: valeur, libelle: valeur };
}
